// Native
import { useState } from "react"
import { Button, DataList, Separator, Text } from "@chakra-ui/react"
import { useNavigate } from "react-router"
import moment from "moment"

// Custom
import { UI } from "components"
import useBonusReport from "hooks/useBonusReport"
import useUser from "hooks/useUser"

export function Resume(){

    const navigate = useNavigate()
    const user = useUser()
    const initial_period = [moment().subtract('months', 10).toDate(), moment().toDate()]
    const [ period, setPeriod ] = useState(initial_period)
    const report = useBonusReport(period)
    
    return(
    <UI.Box loading={report.isLoading}>
        <Text children="Bônus disponível:" color="GrayText" />
        <Text children={<UI.Number.Amount value={user.data?.consultant?.bonus_balance} />} fontSize="2xl" fontWeight="bold" color="green.fg" />
        <Button size="xs" variant="plain" onClick={() => navigate('/financeiro')}><UI.Icon name="withdraw" /> Solicitar saque</Button>
        <Separator my={4} />
        <Text children="Saldo utilizado:" color="GrayText" />
        <Text fontSize="lg" color="red.fg">- <UI.Number.Amount value={report.data?.removed} /></Text>
    </UI.Box>
    )
}

export function Details(){

    const initial_period = [moment().subtract('months', 10).toDate(), moment().toDate()]
    const [ period, setPeriod ] = useState(initial_period)
    const report = useBonusReport(period)

    return(
    <UI.Box loading={report.isLoading}>
        <Text children="Resumo das bonificações:" color="GrayText" />

        <DataList.Root mt={4} orientation="horizontal">
            <DataList.Item>
                <DataList.ItemLabel><UI.Icon name="network" /> Rede:</DataList.ItemLabel>
                <DataList.ItemValue>
                    <Text color="green.fg">
                        <UI.Number.Amount value={report.data?.network} />
                    </Text>
                </DataList.ItemValue>
            </DataList.Item>

            <DataList.Item>
                <DataList.ItemLabel><UI.Icon name="points" /> Pins:</DataList.ItemLabel>
                <DataList.ItemValue>
                    <Text color="green.fg">
                        <UI.Number.Amount value={report.data?.careers} />
                    </Text>
                </DataList.ItemValue>
            </DataList.Item>

            <DataList.Item>
                <DataList.ItemLabel><UI.Icon name="store" /> Pedidos:</DataList.ItemLabel>
                <DataList.ItemValue>
                    <Text color="red.fg">
                        - <UI.Number.Amount value={report.data?.orders} />
                    </Text>
                </DataList.ItemValue>
            </DataList.Item>

            <DataList.Item>
                <DataList.ItemLabel><UI.Icon name="third" /> Terceiros:</DataList.ItemLabel>
                <DataList.ItemValue>
                    <Text color="red.fg">
                        - <UI.Number.Amount value={report.data?.third} />
                    </Text>
                </DataList.ItemValue>
            </DataList.Item>

            <DataList.Item>
                <DataList.ItemLabel><UI.Icon name="withdraws" /> Saques:</DataList.ItemLabel>
                <DataList.ItemValue>
                    <Text color="red.fg">
                        - <UI.Number.Amount value={report.data?.withdrawals} />
                    </Text>
                </DataList.ItemValue>
            </DataList.Item>

            <DataList.Item>
                <DataList.ItemLabel><UI.Icon name="withdraws" /> Outros:</DataList.ItemLabel>
                <DataList.ItemValue>
                    <Text color="green.fg">
                        <UI.Number.Amount value={report.data?.others} />
                    </Text>
                </DataList.ItemValue>
            </DataList.Item>
        </DataList.Root>
    </UI.Box>
    )
}